function validPoint(point) {
  if (!point || point.latitude == null || point.longitude == null) return null;
  const latitude = Number(point.latitude);
  const longitude = Number(point.longitude);
  if (!Number.isFinite(latitude) || !Number.isFinite(longitude)
      || Math.abs(latitude) > 90 || Math.abs(longitude) > 180) return null;
  return [latitude, longitude];
}

function validRoutePoints(points) {
  if (!Array.isArray(points)) return [];
  return points.filter((point) => Array.isArray(point) && point.length >= 2)
    .map((point) => {
      const latitude = Number(point[0]);
      const longitude = Number(point[1]);
      return Number.isFinite(latitude) && Number.isFinite(longitude)
        && Math.abs(latitude) <= 90 && Math.abs(longitude) <= 180
        ? [latitude, longitude] : null;
    })
    .filter(Boolean);
}

// Lesson geography is authoritative for the map camera. In Work Mode the
// selected route wins; while it is unavailable, keep the camera on the pickup.
// Device GPS is only a fallback when no lesson location exists.
export function selectMapViewportPoints({
  surface = "today", pickup, dropoff, device, routePoints = [],
  readinessRoutePoints = [], driving = false,
}) {
  const route = validRoutePoints(routePoints);
  const pickupRoute = surface === "work_mode" && !driving
    ? validRoutePoints(readinessRoutePoints) : [];
  const frameRoute = route.length > 1 ? route : pickupRoute.length > 1 ? pickupRoute : route;
  if (frameRoute.length > 1) return frameRoute;

  const lessonPoints = [validPoint(pickup), validPoint(dropoff)].filter(Boolean);
  if (surface === "work_mode" && lessonPoints.length) return [lessonPoints[0]];
  if (lessonPoints.length) return lessonPoints;

  const fix = validPoint(device);
  if (fix) return [fix];
  return route;
}
